export default `/* Ids Text Component */
:host([hidden]) {
  display: none !important;
}

:host([overflow=ellipsis]) {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}

:host([mask-type=button-mask]),
:host([mask-type=icon-mask]) {
  display: flex;
  align-items: center;
  gap: var(--ids-text-mask-btn-gap);
}
:host([mask-type=button-mask]) .mask-btn,
:host([mask-type=icon-mask]) .mask-btn {
  display: flex;
}

.ids-text {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-weight: var(--ids-font-weight-normal);
  display: block;
  margin: 0;
  color: currentColor;
  font-size: var(--ids-font-size-sm);
  text-decoration: unset;
}
.ids-text.audible {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  position: none;
}
.ids-text.error {
  color: var(--ids-color-text-error);
}
.ids-text.label {
  color: var(--ids-color-text-label);
}
.ids-text.label.color-variant-alternate {
  color: var(--ids-color-text-inverse);
}
.ids-text.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.ellipsis div.has-tab-width {
  max-width: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ids-text.has-line-clamp {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}
.ids-text.bold {
  font-weight: var(--ids-font-weight-bold);
}
.ids-text.semi-bold {
  font-weight: var(--ids-font-weight-semibold);
}
.ids-text.lighter {
  font-weight: var(--ids-font-weight-light);
}
.ids-text.text-align-start {
  text-align: start;
}
.ids-text.text-align-end {
  text-align: end;
}
.ids-text.text-align-center {
  text-align: center;
}
.ids-text.text-align-justify {
  text-align: justify;
}
.ids-text.status-gray::before, .ids-text.status-error::before, .ids-text.status-info::before, .ids-text.status-success::before, .ids-text.status-warning::before {
  display: inline-flex;
  margin-inline-end: var(--ids-input-margin-bottom);
  border-radius: var(--ids-border-radius-circle);
  content: "";
  height: 8px;
  width: 8px;
  position: relative;
  top: -2px;
}
.ids-text.status-gray {
  color: var(--ids-color-text-label);
}
.ids-text.status-gray::before {
  background-color: var(--ids-color-text-label);
}
.ids-text.status-error {
  color: var(--ids-color-text-error);
}
.ids-text.status-error::before {
  background-color: var(--ids-color-text-error);
}
.ids-text.status-info {
  color: var(--ids-color-text-info);
}
.ids-text.status-info::before {
  background-color: var(--ids-color-text-info);
}
.ids-text.status-success {
  color: var(--ids-color-text-success);
}
.ids-text.status-success::before {
  background-color: var(--ids-color-text-success);
}
.ids-text.status-warning {
  color: var(--ids-color-text-warning);
}
.ids-text.status-warning::before {
  background-color: var(--ids-color-text-warning);
}
.ids-text.pre {
  white-space: pre;
}
.ids-text.pre-wrap {
  white-space: pre-wrap;
}
.ids-text.nowrap {
  white-space: nowrap;
}
.ids-text.pre-line {
  white-space: pre-line;
}
.ids-text.break-spaces {
  white-space: break-spaces;
}
.ids-text.normal {
  white-space: normal;
}
.ids-text.word-break-normal {
  word-break: normal;
}
.ids-text.word-break-break-all {
  word-break: break-all;
}
.ids-text.word-break-keep-all {
  word-break: keep-all;
}
.ids-text.word-break-break-word {
  overflow-wrap: anywhere;
}

:host(.inline) .ids-text {
  display: inline;
}

:host([word-wrap]) {
  white-space: normal;
  /* stylelint-disable-next-line property-no-deprecated */
  word-wrap: break-word;
}

.inline,
[display=inline] {
  display: inline;
}

.ids-text-color-unset {
  color: unset;
}

:host(.message-text) .ids-text {
  color: unset;
}
:host(.message-text) .ids-text.error {
  color: unset;
}

::slotted(.highlight) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(.audible) {
  /* stylelint-disable-next-line property-no-deprecated */
  clip: rect(0, 0, 0, 0);
  height: 0;
  line-height: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

::slotted(.filter) {
  font-weight: var(--ids-font-weight-bold);
}

::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin);
  vertical-align: middle;
  position: relative;
  top: -2px;
}

:host([font-size="32"]) ::slotted(ids-icon),
:host([font-size="28"]) ::slotted(ids-icon),
:host([font-size="24"]) ::slotted(ids-icon),
:host([font-size="20"]) ::slotted(ids-icon) {
  margin-inline-end: var(--ids-text-icon-margin-lg);
}

::slotted(ids-alert) {
  margin: var(--ids-text-alert-margin);
  vertical-align: sub;
}

/* Ids Typography System */
.ids-text-10 {
  font-size: var(--ids-font-size-3xs);
  text-transform: uppercase;
}

.ids-text-12 {
  font-size: var(--ids-font-size-2xs);
  text-transform: uppercase;
}

.ids-text-14 {
  font-size: var(--ids-font-size-xs);
}

.ids-text-16 {
  font-size: var(--ids-font-size-sm);
}

.ids-text-20 {
  font-size: var(--ids-font-size-md);
}

.ids-text-24 {
  font-size: var(--ids-font-size-lg);
}

.ids-text-28 {
  font-size: var(--ids-font-size-xl);
}

.ids-text-32 {
  font-size: var(--ids-font-size-2xl);
}

.ids-text-40 {
  font-size: var(--ids-font-size-3xl);
}

.ids-text-48 {
  font-size: var(--ids-font-size-4xl);
}

.ids-text-60 {
  font-size: var(--ids-font-size-5xl);
}

.ids-text-72 {
  font-size: var(--ids-font-size-6xl);
  margin-block-end: 0;
}

.ids-text-color-muted.ids-text,
:host([disabled]) .ids-text {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.label,
:host([disabled]) .ids-text.label {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.color-variant-alternate.label,
:host([disabled]) .ids-text.color-variant-alternate.label {
  color: var(--ids-color-text-subtle);
}
.ids-text-color-muted.ids-text.status-base, .ids-text-color-muted.ids-text.status-error, .ids-text-color-muted.ids-text.status-info, .ids-text-color-muted.ids-text.status-success, .ids-text-color-muted.ids-text.status-warning,
:host([disabled]) .ids-text.status-base,
:host([disabled]) .ids-text.status-error,
:host([disabled]) .ids-text.status-info,
:host([disabled]) .ids-text.status-success,
:host([disabled]) .ids-text.status-warning {
  color: var(--ids-color-text-disabled);
}
.ids-text-color-muted.ids-text.status-error::before, .ids-text-color-muted.ids-text.status-info::before, .ids-text-color-muted.ids-text.status-success::before, .ids-text-color-muted.ids-text.status-warning::before,
:host([disabled]) .ids-text.status-error::before,
:host([disabled]) .ids-text.status-info::before,
:host([disabled]) .ids-text.status-success::before,
:host([disabled]) .ids-text.status-warning::before {
  background-color: var(--ids-color-text-disabled);
}

:host([class=label-checkbox]) .audible {
  position: relative;
  line-height: 1;
  height: unset;
}

::slotted(ids-badge) {
  position: relative;
  margin-inline-start: 8px;
  top: 1px;
  vertical-align: top;
}

:host([label-wrap=ellipsis]) .ids-text {
  display: block;
  width: 100%;
  max-inline-size: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=ellipsis-no-stretch]) .ids-text {
  display: block;
  max-inline-size: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host([label-wrap=wrap-no-stretch]) .ids-text {
  max-inline-size: 75%;
}

:host([label-wrap=wrap]) .ids-text,
:host([label-wrap=wrap-no-stretch]) .ids-text {
  overflow-wrap: anywhere;
}

:host([label-width]),
:host([label-width]) .ids-text,
:host([label-width][tooltip]) .ids-text,
:host([label-width][label-wrap=ellipsis-no-stretch]) .ids-text,
:host([label-width][label-wrap=wrap-no-stretch]) .ids-text {
  display: block;
  width: var(--ids-label-width);
  max-inline-size: var(--ids-label-width);
  inline-size: var(--ids-label-width);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
